import React from "react";
import PropTypes from "prop-types";
import style from "../../stylesheets/FilterOption.module.scss";
import extraStyle from "../../stylesheets/StoreFilter.module.scss";
import mobileStyle from "../../stylesheets/MobileFilter.module.scss";

import { CLOSE_MENU_PSEUDO_FACET_ID } from "../../constants";

const CategoryFilterOption = ({
  filterOption,
  facetName,
  showDropdown,
  showingLowestCategoryLevel,
  isCurrentFilter,
  isMobile,
  handleCategoryFilterClick,
}) => {
  // selected filter
  const selectedCategoryFilterClass = isCurrentFilter
    ? style.selectedCategoryFilter
    : "";

  const handleClick = () => {
    if (isCurrentFilter && showingLowestCategoryLevel) {
      if (!isMobile) {
        showDropdown(CLOSE_MENU_PSEUDO_FACET_ID);
      }
    } else {
      filterOption.facet_name = facetName;
      handleCategoryFilterClick(filterOption);
    }
  };

  const filterOptionName = (
    <div
      className={`${style.filterOptionName} ${extraStyle.filterOptionName} ${mobileStyle.categoryFilterOptionName}`}
    >
      {filterOption.name}
    </div>
  );

  return (
    <div className={`${selectedCategoryFilterClass}`} onClick={handleClick}>
      <li value={filterOption.id}>
        {filterOptionName}
        <div
          className={`${extraStyle.filterOptionCount} ${mobileStyle.filterOptionCount}`}
        >
          {filterOption.count}
        </div>
      </li>
    </div>
  );
};

CategoryFilterOption.propTypes = {
  filterOption: PropTypes.object.isRequired,
  facetName: PropTypes.string.isRequired,
  isCurrentFilter: PropTypes.bool.isRequired,
  showingLowestCategoryLevel: PropTypes.bool.isRequired,
  handleCategoryFilterClick: PropTypes.func.isRequired,
  showDropdown: PropTypes.func.isRequired,
  isMobile: PropTypes.bool.isRequired,
};

export default CategoryFilterOption;
